import { render, staticRenderFns } from "./CollectorDataIcons.vue?vue&type=template&id=ac61f036&scoped=true&"
import script from "./CollectorDataIcons.vue?vue&type=script&lang=js&"
export * from "./CollectorDataIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac61f036",
  null
  
)

export default component.exports